import { useState,useEffect } from "react";
import { useDispatch } from "react-redux";
import { closeProductModal, refreshProductList } from "../../../redux/features/productModalSlice";
import { AddBrand } from "../../../redux/services/BrandService/brand.Services";
import { ActiveCategoryList } from "../../../redux/services/categoriesService/categories.Services";
// import { ActiveSubCategoryList } from "../../../redux/services/subCategoriesService/subCategories.Services";
import Swal from "sweetalert2";
import { errorToast, successToast } from "../../../Utils/toast";

function CreateBrand({ refreshData }) {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [logoFile, setLogoFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  console.log("subcategory",subCategories)
  const [formData, setFormData] = useState({
    category_id: "",
    // sub_category_id: "",
    name: "",
    status: 1,
    logo: null
  });

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   const val = type === 'checkbox' ? (checked ? 1 : 0) : value;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: val,
  //   }));
  //   if (errors[name]) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [name]: null,
  //     }));
  //   }
  // };
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await ActiveCategoryList();

      if (res?.success) {
        setCategories(res.data || []);

      }
    } catch (error) {
      console.log(error);
      errorToast("Something went wrong");
    }
  };
  // const fetchSubCategories = async (categoryId) => {
  //   try {
  //     const res = await ActiveSubCategoryList({
  //       category_id: categoryId,
  //     });
  //   console.log("API Response:", res);
  //       if (res?.data?.success) {
  //     setSubCategories(res.data.data || []);
  //   } else {
  //     setSubCategories([]);
  //   }
  //   } catch (error) {
  //     console.log(error);
  //     errorToast("Something went wrong");
  //   }
  // };
const handleChange = async (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
    ...(name === "category_id" && {
      sub_category_id: "",
    }),
  }));

  // Category select hote hi API call
  // if (name === "category_id") {
  //   if (value) {
  //     await fetchSubCategories(value);
  //   } else {
  //     setSubCategories([]);
  //   }
  // }

  if (errors[name]) {
    setErrors((prev) => ({
      ...prev,
      [name]: null,
    }));
  }
};
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      setFormData((prev) => ({
        ...prev,
        logo: file
      }));
    }
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = ["Brand Name is required"];
    }
    if (!formData.category_id.trim()) {
      newErrors.category_id = ["Please Select Category"];
    }
    // if (!formData.sub_category_id.trim()) {
    //   newErrors.sub_category_id = ["Please Select SubCategory"];
    // }
    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }

    try {
      setLoading(true);

      const formDataToSend = new FormData();

      formDataToSend.append("category_id", formData.category_id);
      // formDataToSend.append("sub_category_id", formData.sub_category_id);
      formDataToSend.append("name", formData.name);
      formDataToSend.append("status", formData.status);
      if (logoFile) {
        formDataToSend.append('logo', logoFile);
      }
      const res = await AddBrand(formDataToSend);
      if (res?.success === true) {
        successToast(res?.message);
        dispatch(closeProductModal());
        dispatch(refreshProductList());
      } else {
        errorToast(res?.data?.message || "Failed to create brand");
      }
    } catch (error) {
      console.error("Error creating brand:", error);

      if (error?.response?.status === 422) {
        // Validation errors
        setErrors(error.response.data.errors || {});
        errorToast("Validation Error", "Please check the form fields", "error");
      } else {
        // Other errors
        errorToast("Error", error?.response?.data?.message || "Something went wrong", "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main_page">
      <form onSubmit={handleSubmit} className="row g-3">

        <div className="col-md-6">
          <label>
            Category <span className="text-danger">*</span>
          </label>

          <select
            className={`form-control ${errors?.category_id ? "is-invalid" : ""
              }`}
            name="category_id"
            value={formData.category_id}
            onChange={handleChange}
          >
            <option value="">Select Category</option>

            {categories.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>

          {errors?.category_id && (
            <div className="invalid-feedback d-block">
              {errors.category_id[0]}
            </div>
          )}
        </div>
        {/* <div className="col-md-6">
          <label>
            Sub Category <span className="text-danger">*</span>
          </label>

          <select
            className={`form-control ${errors?.sub_category_id ? "is-invalid" : ""
              }`}
            name="sub_category_id"
            value={formData.sub_category_id}
            onChange={handleChange}
          >
            <option value="">Select Sub Category</option>

            {subCategories.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>

          {errors?.sub_category_id && (
            <div className="invalid-feedback d-block">
              {errors.sub_category_id[0]}
            </div>
          )}
        </div> */}



        <div className="col-md-6">
          <label>Brand Name <span className="text-danger">*</span></label>
          <input
            placeholder="Brand"
            className={`form-control ${errors?.name ? "is-invalid" : ""}`}
            value={formData.name}
            onChange={handleChange}
            name="name"
            disabled={loading}
          />
          {errors?.name && (
            <div className="invalid-feedback d-block">
              {Array.isArray(errors.name) ? errors.name[0] : errors.name}
            </div>
          )}
        </div>
        <div className="col-md-6">
          <label>Logo</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleLogoChange}
            disabled={loading}
          />
          {logoFile && (
            <div className="mt-2">
              <img
                src={URL.createObjectURL(logoFile)}
                alt="Logo preview"
                style={{ width: '100px', height: '100px', objectFit: 'contain' }}
              />
            </div>
          )}
        </div>
        <div className="mb-3">
          <label>Status</label>
          <select
            className="form-control"
            name="status"
            value={formData.status}
            onChange={handleChange}
            disabled={loading}
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </select>
        </div>
        <button
          className="add-btn"
          type="submit"
          disabled={loading}
        >
          {loading ? "Creating..." : "Create Brand"}
        </button>
      </form>
    </div>
  );
}

export default CreateBrand;